import { UserAccount } from '@app/models/account.model';

export function formatRoleLabel(name: string): string {
  return name
    .replace(/[_-]+/g, ' ')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\s+/g, ' ')
    .trim();
}

export function formatUserName(user?: UserAccount | null): string {
  if (!user) return '—';

  const fullName = [
    user.personalData?.firstName,
    user.personalData?.midName,
    user.personalData?.lastName,
  ]
    .filter(Boolean)
    .join(' ')
    .trim();

  return fullName || user.userName || '—';
}
